import { render, staticRenderFns } from "./BlogDeleteModal.vue?vue&type=template&id=d79bc816&scoped=true&"
import script from "./BlogDeleteModal.vue?vue&type=script&lang=js&"
export * from "./BlogDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d79bc816",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d79bc816')) {
      api.createRecord('d79bc816', component.options)
    } else {
      api.reload('d79bc816', component.options)
    }
    module.hot.accept("./BlogDeleteModal.vue?vue&type=template&id=d79bc816&scoped=true&", function () {
      api.rerender('d79bc816', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Admin/Blog/BlogDeleteModal.vue"
export default component.exports